import React from 'react';
import { Empty, Button } from 'antd';

interface Props {
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
}

export const EmptyState: React.FC<Props> = ({ title, description, action }) => (
  <div style={{ padding: '40px 16px', textAlign: 'center' }}>
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <span>
          {title}
          {description && (
            <>
              <br />
              <span style={{ fontSize: 13, opacity: 0.6 }}>{description}</span>
            </>
          )}
        </span>
      }
    />
    {action && (
      <Button type="primary" style={{ marginTop: 16 }} onClick={action.onClick}>
        {action.label}
      </Button>
    )}
  </div>
);
